/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import { bedrockReflections } from "@/reflection/bedrock.reflections"

const viewModules = import.meta.glob("@/reflection/**/*.vue")

export function mapNavigationRoutes(items) {

    return items
        .filter(item => item.active !== false && item.visible !== false)
        .map(item => {

            const viewPath = `/src/reflection/Core/${item.entity_key}/${item.component}.vue`

            const view = viewModules[viewPath]

            if (!view) {
                console.warn(`Bedrock Router: View not found for ${item.component} at path ${viewPath}`)
            }

            return {

                path: item.route,

                component: view,

                meta: {

                    requiresAuth: true,

                    entity: item.entity_key,

                    header: {

                        title: item.label,

                        subtitle: item.meta?.subtitle ?? "",

                        breadcrumb: [
                            { label: item.meta?.group ?? "Core", to: "/" },
                            { label: item.label, to: item.route }
                        ],

                        actions: item.meta?.actions ?? [],

                        tags: item.meta?.tags ?? {}

                    }

                }

            }

        })

}